<div class="col-12 px-0">
    <p class="subTitle text-center"> Malla Societaria</p>
</div>

<div class="container-fluid d-flex justify-content-center">
    <div id="container"></div>
</div>